export default __webpack_public_path__ + "static/media/SUZUKI.588f16c4.png";